// Pousada / Hotel — hospitalidade, turismo, aconchego
// Tons terrosos e dourados, cantos arredondados, acolhedor
module.exports = {
  effect: 'none',
  colors: {
    main:            { light: '#fdf6ee', dark: '#1a1208' },
    card:            { light: '#f5ede0', dark: '#241a0e' },
    surface:         { light: '#e8d9c4', dark: '#2e2010' },
    action:          { light: '#a07850', dark: '#d4a96a' },
    actionHover:     { light: '#7d5c38', dark: '#c4954a' },
    textPrimary:     { light: '#1a1208', dark: '#fdf6ee' },
    textSecondary:   { light: '#3d2810', dark: '#e8d4b8' },
    textMuted:       { light: '#7a5a38', dark: '#c4a070' },
    textMutedSubtle: { light: '#a07850', dark: '#a07850' },
    border:          { light: '#c8a880', dark: '#4a3018' },
    borderSubtle:    { light: '#dfc9a8', dark: '#382410' },
    link:            { light: '#a07850', dark: '#d4a96a' },
    linkBg:          { light: '#fff8f0', dark: 'rgba(160,120,80,0.15)' },
    linkBorder:      { light: '#e8c89c', dark: '#a07850' },
    linkHover:       { light: '#f5eddc', dark: 'rgba(160,120,80,0.28)' },
    inputBg:         { light: '#ffffff', dark: '#241a0e' },
    inputBorder:     { light: '#c8a880', dark: '#4a3018' },
    inputText:       { light: '#1a1208', dark: '#fdf6ee' },
    focusRing:       { light: '#a07850', dark: '#d4a96a' },
    overlay:         { light: 'rgba(0,0,0,0.5)', dark: 'rgba(0,0,0,0.75)' },
    confirm:         { light: '#7a5a38', dark: '#4a3018' },
    confirmHover:    { light: '#5c4028', dark: '#5a3c20' },
    confirmText:     { light: '#ffffff', dark: '#fdf6ee' },
    confirmBg:       { light: '#fdf6ee', dark: '#241a0e' },
    confirmBorder:   { light: '#dfc9a8', dark: '#4a3018' },
    success:         { light: '#065f46', dark: '#34d399' },
    successHover:    { light: '#022c22', dark: '#10b981' },
    successBg:       { light: '#ecfdf5', dark: 'rgba(6,78,59,0.3)' },
    successText:     { light: '#10b981', dark: '#6ee7b7' },
    successBorder:   { light: '#a7f3d0', dark: '#065f46' },
    error:           { light: '#b91c1c', dark: '#f87171' },
    errorHover:      { light: '#991b1b', dark: '#ef4444' },
    errorBg:         { light: '#fef2f2', dark: 'rgba(127,29,29,0.3)' },
    errorText:       { light: '#ef4444', dark: '#fca5a5' },
    errorBorder:     { light: '#fecaca', dark: '#7f1d1d' },
    info:            { light: '#1e40af', dark: '#60a5fa' },
    infoHover:       { light: '#1d4ed8', dark: '#3b82f6' },
    infoBg:          { light: '#eff6ff', dark: 'rgba(30,58,138,0.3)' },
    infoText:        { light: '#3b82f6', dark: '#93c5fd' },
    infoBorder:      { light: '#bfdbfe', dark: '#1e3a8a' },
  },
  borderRadius: {
    card:      '32px',
    container: '20px',
    page:      '28px',
    button:    '9999px',
    input:     '16px',
    badge:     '10px',
    full:      '9999px',
  },
  borderWidth: {
    default: '1px',
    thick:   '2px',
    avatar:  '5px',
    device:  '7px',
  },
  textures: {
    main:    { light: '', dark: '', size: '0', blendLight: 'normal', blendDark: 'normal', opacityLight: 0, opacityDark: 0 },
    surface: { light: '', dark: '' },
    card:    { light: '', dark: '' },
  },
};
